export const BOX_BORDER_RADIUS = 10;
export const BOX_BORDER_RADIUS_PX = BOX_BORDER_RADIUS + "px";
export const VERTICAL_SPACING = 12;
export const VERTICAL_SPACING_PX = VERTICAL_SPACING + 'px';
export const HORIZONTAL_SPACING = 12;
export const HORIZONTAL_SPACING_PX = HORIZONTAL_SPACING + 'px';

